<template>
  <div :class="`${height} ${textColor}`">
    <div :class="`w-full flex items-center justify-center ${isMobileScreen ? '' : 'gap-x-3'} py-2 px-2 fixed-top z-50 ${bgColor} ${height}`">
      <slot>
      </slot>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import { isMobile } from '@/utils/general'

@Component({
  name: 'Banner',
  methods: { isMobile }
})
export default class extends Vue {
  @Prop({ default: 'bg-red-500' }) bgColor!: string;
  @Prop({ default: 'h-5' }) height!: string;
  @Prop({ default: 'text-white' }) textColor!: string;
  isMobileScreen = isMobile();
}
</script>

<style scoped>

</style>
